import React, { useEffect } from "react";
import BannerClient from "./Body/BannerClient";
import { validationLan } from "../../../ValidationLan/ValidationLan";

const Client = () => {
  let isArabic = localStorage.getItem("lan") === "AR";
  useEffect(() => {
    validationLan();
  }, [isArabic]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <BannerClient />;
};

export default Client;
